import { forwardRef } from 'react';
import { connect } from 'react-redux';
import StudentList from './StudentList';
import ModeSelector from './ModeSelector';
import { selectClassroom } from '../Classrooms';
import ClassCodeManager from './ClassCodeManager';
import { ClassroomType, AddStudentModeType } from '../../peekapak-types/DataProtocolTypes';
import styles from '../SCSS/StudentListOrModeSelector.module.scss';

interface Props {
  classroom: ClassroomType;
}

const StudentListOrModeSelector = (props: Props) => {
  //if ( props.studentList && props.studentList.length > 0  ) {
  //
  //if ( true ) {
  if (props.classroom.grade && props.classroom.grade > 5) {
    return (
      <div className={styles.mainSegment}>
        <StudentList {...props} innerRef={props.innerRef} />
      </div>
    );
  }
  if (props.classroom.addStudentMode && props.classroom.addStudentMode === AddStudentModeType.MANUAL) {
    return (
      <div className={styles.mainSegment}>
        <StudentList {...props} innerRef={props.innerRef} />
      </div>
    );
  }

  if (props.classroom.addStudentMode && props.classroom.addStudentMode === AddStudentModeType.CLASS_CODE) {
    return (
      <div className={styles.mainSegment}>
        <ClassCodeManager {...props} ref={props.innerRef} />
      </div>
    );
  }

  return (
    <div className={styles.studentListOrModeSelector}>
      <div className={styles.title}>How would you like to add students to this classroom?</div>
      <ModeSelector {...props} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  classroom: selectClassroom(state),
  userProfile: state.user.userProfile,
});

const ConnectedStudentListOrModeSelector = connect(mapStateToProps, null)(StudentListOrModeSelector);
export default forwardRef((props, ref) => <ConnectedStudentListOrModeSelector {...props} innerRef={ref} />);
